{
  "header": "자산 세부 정보",
  "subtitle": "트럭에 연결된 자산(트레일러, 컨테이너 등)입니다.",
  "assetType": "자산 유형",
  "assetTypePlaceholder": "자산 유형 선택",
  "assetId": "자산 ID(예: 트레일러 번호)",
  "assetIdPlaceholder": "예: 트레일러 번호, 컨테이너 ID 등",
  "remove": "삭제",
  "addAnother": "다른 자산 추가",
  "trailerType": "트레일러 유형",
  "trailerId": "트레일러 ID"
}
